<template>
    <div class="grid grid-cols-3 gap-4 p-4 bg-gray-50">
        <!-- First Column -->
        <div class="space-y-4">
            <lens-order-parameters-table-card :order="row" />
        </div>

        <!-- Second Column -->
        <div class="space-y-4">
            <order-return-conditions-card :order="row" />

            <order-delivery-card :order="row" />
        </div>

        <!-- Third Column -->
        <div class="space-y-4">
            <lens-price-card
                v-if="can('price:view')"
                :order="row"
            />

            <order-journal-card
                v-if="isStaff"
                :order="row"
            />

            <uploaded-files-card v-if="row.fitting_session_id" :order="row" />

            <div class="flex flex-wrap justify-end gap-2">
                <view-comments-card :order="row" />

                <order-actions-card
                    v-if="can('order:delete')"
                    :order="row"
                    @remove="$emit('remove', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import LensOrderParametersTableCard from '@/components/cards/LensOrderParametersTableCard.vue';
import OrderReturnConditionsCard from '@/components/cards/OrderReturnConditionsCard.vue';
import OrderDeliveryCard from '@/components/cards/OrderDeliveryCard.vue';
import LensPriceCard from '@/components/cards/LensPriceCard.vue';
import OrderJournalCard from '@/components/cards/OrderJournalCard.vue';
import UploadedFilesCard from '@/components/cards/UploadedFilesCard.vue';
import OrderActionsCard from '@/components/cards/OrderActionsCard.vue';
import ViewCommentsCard from '@/components/cards/ViewCommentsCard.vue';

const store = useStore();

const props = defineProps({
    row:
    {
        type:     Object,
        required: true,
    },

    updating:
    {
        type:    Boolean,
        default: false,
    },
});

const emit = defineEmits(['remove']);

const can = computed(() => store.getters['account/can']);
const isStaff = computed(() => store.getters['account/isStaff']);
</script>
